import {
  HStack,
  Spacer,
  Stack,
  VStack
} from "@chakra-ui/react"
import { Button, Text } from "@/components"
import { StockOptionType, TaxCalculation } from "@/types"
import { TaxCalculationRow } from "./TaxCalculationRow"

interface Props {
  taxCalculations: TaxCalculation[]
  setTaxCalculations: (taxCalculations: TaxCalculation[]) => any
}

export const OptionsInfoComponent = ({ taxCalculations, setTaxCalculations }: Props) => {
  const setAmount = (index: number, amount: number) => {
    const _taxCalculations = [...taxCalculations]
    const taxCalculation = _taxCalculations[index]
    taxCalculation.amount = amount
    setTaxCalculations(_taxCalculations)
  }

  const setStrikePrice = (index: number, strikePrice: number) => {
    const _taxCalculations = [...taxCalculations]
    const taxCalculation = _taxCalculations[index]
    taxCalculation.strikePrice = strikePrice
    setTaxCalculations(_taxCalculations)
  }

  const setStockOptionType = (index: number, type: string) => {
    const _taxCalculations = [...taxCalculations]
    const taxCalculation = _taxCalculations[index]
    let stockOptionType = StockOptionType.ISO
    if (type.toLowerCase() === StockOptionType.NSO) stockOptionType = StockOptionType.NSO
    taxCalculation.type = stockOptionType
    setTaxCalculations(_taxCalculations)
  }

  const addNewTaxCalculation = () => {
    const _taxCalculations = [...taxCalculations]
    _taxCalculations.push({ amount: 1, strikePrice: 0.01, type: StockOptionType.ISO })
    setTaxCalculations(_taxCalculations)
  }

  const deleteTaxCalculation = (index: number) => {
    if (taxCalculations.length > 1) {
      const _taxCalculations = [...taxCalculations]
      _taxCalculations.splice(index, 1)
      setTaxCalculations(_taxCalculations)
    }
  }

  return (
    <Stack w="100%" borderTopRadius={10} pb={10}>
      <Text fontSize="large" fontWeight="bold">
        Options Info
      </Text>
      <Text fontSize="sm" color="text.muted" pb={10}>
        Fill out your exercise information below
      </Text>
      <VStack gap={10}>
        {
          taxCalculations.map((taxCalculation, index) => {
            return (
              <TaxCalculationRow
                key={index}
                index={index}
                taxCalculation={taxCalculation}
                isDeletable={taxCalculations.length > 1}
                setAmount={setAmount}
                setStrikePrice={setStrikePrice}
                setStockOptionType={setStockOptionType}
                deleteTaxCalculation={deleteTaxCalculation}
              />
            )
          })
        }
      </VStack>
      <HStack pt={10}>
        <Spacer />
        <Button variant="outline" onClick={() => addNewTaxCalculation()}>
          Add another grant
        </Button>
        <Spacer />
      </HStack>
    </Stack>
  )
}